// ** React Imports
import { Dispatch, SetStateAction, useState } from 'react'

// ** MUI Imports
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Box, { BoxProps } from '@mui/material/Box'

// ** Icons Imports
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'

// ** Styled Components
const ChatFormWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  borderRadius: 100,
  alignItems: 'center',
  boxShadow: theme.shadows[1],
  padding: 6,
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.paper
}))

const CustomSearchBox = ({ setSearchValue, mobile }: { setSearchValue: Dispatch<SetStateAction<string>>, mobile : boolean }) => {
  const [value, setValue] = useState('')


  return (
    <ChatFormWrapper sx={{ mx: mobile ? 0 : 20 }}>
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
        <TextField
          fullWidth
          size='small'
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={e => e.key == 'Enter' && setSearchValue(value)}
          placeholder='cari lowongan Bankaltimtara . . .'
          sx={{
            pl: 6,
            '& .MuiOutlinedInput-input': { pl: 0 },
            '& fieldset': { border: '0 !important' },
            '& ::placeholder': { opacity: 1, color: theme => theme.palette.text.primary, fontStyle: 'italic' }
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant='contained'
          color='error'
          disabled={value == ''}
          onClick={() => {
            setValue('')
            setSearchValue('')
          }}
          sx={{ borderRadius: 10, minWidth: 0, width: 48, height: 48, mr: 2 }}
        >
          <ClearRoundedIcon fontSize='medium' />
        </Button>
        <Button
          variant='contained'
          onClick={() => setSearchValue(value)}
          sx={{ borderRadius: 10, minWidth: 0, width: 48, height: 48 }}
        >
          <SearchRoundedIcon fontSize='medium' />
        </Button>
      </Box>
    </ChatFormWrapper>
  )
}

export default CustomSearchBox
